import { FormField, Text } from '@domain-group/suit-theme'

import type { BulkShareArtworksPayload } from '@hooks/useBulkShareArtworks'

import User from './User'

interface UserListProps {
  bulkShareArtworksPayload: BulkShareArtworksPayload,
}

const UserList = (props: UserListProps) => {
  const {
    bulkShareArtworksPayload: {
      agentUsers,
      artworkReviewUrls: { privateUrl },
      callbacks: {
        prepareUrl,
        presignUrl,
      },
      entities: {
        images,
      },
    },
  } = props

  return (
    <FormField direction="column" label="Send to Agents" marginTop="large">
      <Text color="bodyFontLightColor" fontSize="xsmall" lineHeight="1.3" marginTop="small">
        Users will be able to comment on artworks, download and view any artworks included in the above selection.
      </Text>

      {agentUsers.map((agentUser) => {
        // @ts-expect-error TS18048
        const image = images[agentUser.image_id] || {}

        return (
          <User
            artworkReviewUrl={privateUrl}
            callbacks={{
              prepareUrl,
              // @ts-expect-error TS2345
              presignUrl: () => presignUrl(agentUser),
            }}
            image={image}
            // @ts-expect-error TS18048
            key={agentUser.id}
            // @ts-expect-error TS2322
            user={agentUser}
          />
        )
      })}
    </FormField>
  )
}

export default UserList
